// src/services/teamService.js
import { configuredAxios } from './axiosConfig';

const teamService = {
  getAll: async () => {
    try {
      const response = await configuredAxios.get('/teams');
      return response.data;
    } catch (error) {
      console.error('Error fetching teams:', error);
      throw error;
    }
  },

  // ✅ AGORA ACEITA championshipId COMO PARÂMETRO OPCIONAL
  getTeamById: async (id, championshipId) => {
    try {
      const url = championshipId ? `/teams/${id}?championshipId=${championshipId}` : `/teams/${id}`;
      const response = await configuredAxios.get(url);
      return response.data;
    } catch (error) {
      console.error(`Error fetching team ${id}:`, error);
      throw error;
    }
  },

  // ✅ ALIAS COM MESMA ASSINATURA
  getById: async (id, championshipId) => {
    try {
      const url = championshipId ? `/teams/${id}?championshipId=${championshipId}` : `/teams/${id}`;
      const response = await configuredAxios.get(url);
      return response.data;
    } catch (error) {
      console.error(`Error fetching team ${id}:`, error);
      throw error;
    }
  },

  createTeam: async (formData) => {
    try {
      const response = await configuredAxios.post('/teams', formData);
      return response.data;
    } catch (error) {
      console.error('Error creating team:', error);
      throw error;
    }
  },

  updateTeam: async (id, formData) => {
    try {
      const response = await configuredAxios.put(`/teams/${id}`, formData);
      return response.data;
    } catch (error) {
      console.error(`Error updating team ${id}:`, error);
      throw error;
    }
  },

  deleteTeam: async (id) => {
    try {
      const response = await configuredAxios.delete(`/teams/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting team ${id}:`, error);
      throw error;
    }
  },

  addPlayerToTeam: async (teamId, playerData) => {
    try {
      const response = await configuredAxios.post(`/teams/${teamId}/players`, playerData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response;
    } catch (error) {
      console.error(`Error adding player to team ${teamId}:`, error);
      throw error;
    }
  },
  
  getTeamsByChampionship: async (championshipId) => {
    try {
      const response = await configuredAxios.get(`/championships/${championshipId}/teams`);
      return response.data.data || response.data;
    } catch (error) {
      console.error(`Error fetching teams for championship ${championshipId}:`, error);
      throw error;
    }
  },

  removeTeamFromChampionship: async (championshipId, teamId) => {
    try {
      const response = await configuredAxios.delete(`/championships/${championshipId}/teams/${teamId}`);
      return response.data;
    } catch (error) {
      console.error(`Error removing team ${teamId} from championship ${championshipId}:`, error);
      throw error;
    }
  },

  removePlayerFromTeam: async (teamId, playerId) => {
    try {
      const response = await configuredAxios.delete(`/teams/${teamId}/players/${playerId}`);
      return response.data;
    } catch (error) {
      console.error(`Error removing player ${playerId} from team ${teamId}:`, error);
      throw error;
    }
  },
};

export default teamService;